import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { usePagesTranslation } from "../locales";

/** Compact company intro on the public homepage, linking to the full About Us page. */
export default function LandingAboutUsSection() {
    const { t } = usePagesTranslation();

    return (
        <section className="pi-section" id="about-us" aria-labelledby="pi-about-title">
            <div className="pi-landing__inner">
                <header className="pi-section__head">
                    <p className="pi-section__kicker">
                        {t("landing.about-us", "About Us")}
                    </p>
                    <h2 className="pi-section__title" id="pi-about-title">
                        {t("about.slogan", "Solve, Connect, Understand")}
                    </h2>
                    <p className="pi-section__subtitle">
                        {t(
                            "about.intro",
                            "We make puzzles that guide your logic — they help you see the next step without giving the answer away.",
                        )}
                    </p>
                </header>
                <p className="pi-about__body">
                    {t(
                        "about.productsBody",
                        "Play crossword, word search, hidden message, sliding, jigsaw, and word-wheel puzzles in your browser. Our mobile apps — Sliding Puzzle Quest, Jigsaw Muse, and Word Wheel Quest — are built for one-handed play on iPhone and Android.",
                    )}
                </p>
                <RouterLink className="pi-about__cta" to="/about">
                    {t("about.readMore", "Read more about us")}
                </RouterLink>
            </div>
        </section>
    );
}
